/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlRemoveYourListsResponse
 */
export interface ControlRemoveYourListsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlRemoveYourListsResponse
     */
    form_ids: Array<string>;
}

/**
 * Check if a given object implements the ControlRemoveYourListsResponse interface.
 */
export function instanceOfControlRemoveYourListsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "form_ids" in value;

    return isInstance;
}

export function ControlRemoveYourListsResponseFromJSON(json: any): ControlRemoveYourListsResponse {
    return ControlRemoveYourListsResponseFromJSONTyped(json, false);
}

export function ControlRemoveYourListsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlRemoveYourListsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form_ids': json['form_ids'],
    };
}

export function ControlRemoveYourListsResponseToJSON(value?: ControlRemoveYourListsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form_ids': value.form_ids,
    };
}

